import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';

import { useUser } from '~/api/user';
import { Container, Dialog, Header, Tabs } from '~/components';
import { productFruitsIds } from '~/constants/productFruits';
import { SearchParamKeys } from '~/constants/url';
import { EnableCommunityProfileDialog } from '~/features/community';
import { routes } from '~/providers/RouterProvider/router.routes';
import { qs } from '~/utils/searchParams';

export const JobPostsOverviewLayout = () => {
  const { data: user } = useUser();

  const { t } = useTranslation(['jobPosts']);

  const { pathname } = useLocation();

  const enableCommunityProfileHandle = Dialog.useHandle();

  return (
    <>
      <Header.Root>
        <Header.Content title={t('jobPosts:overview.title')} />

        <Header.Actions>
          <Header.LinkAction
            data-pf-id={productFruitsIds.jobPosts.header.createJobPost}
            icon="Add"
            onClick={(e) => {
              if (!user.communityProfile.enabled) {
                e.preventDefault();
                enableCommunityProfileHandle.open(null);
              }
            }}
            to={{ pathname: routes.createJobPost, search: qs({ [SearchParamKeys.REDIRECT_PATH]: location.pathname + location.search }) }}
          >
            {t('jobPosts:overview.actions.create')}
          </Header.LinkAction>
        </Header.Actions>

        <Header.Tabs>
          <Tabs.Root value={pathname}>
            <Tabs.List>
              <Tabs.TabLink preventScrollReset replace to={routes.jobPosts} value={routes.jobPosts}>
                {t('jobPosts:tabs.all')}
              </Tabs.TabLink>

              <Tabs.TabLink preventScrollReset replace to={routes.bookmarkedJobPosts} value={routes.bookmarkedJobPosts}>
                {t('jobPosts:tabs.bookmarked')}
              </Tabs.TabLink>

              <Tabs.TabLink preventScrollReset replace to={routes.ownJobPosts} value={routes.ownJobPosts}>
                {t('jobPosts:tabs.own')}
              </Tabs.TabLink>
            </Tabs.List>
          </Tabs.Root>
        </Header.Tabs>
      </Header.Root>

      <Container>
        <Outlet />
      </Container>

      <Dialog.Root handle={enableCommunityProfileHandle}>
        <EnableCommunityProfileDialog />
      </Dialog.Root>
    </>
  );
};
